import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UiArguments } from "@recore-solutions/nstar-lib";
import { of } from "rxjs";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";

@Injectable({ providedIn: "root" })
export class ListingCityFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (_uiArguments: UiArguments) => {
		return (_term: any, additionalParams: any[]) => {
			const citySK =
				typeof additionalParams[0] === "number" ? additionalParams[0] : additionalParams[0]?.key;
			const postalCitySK =
				typeof additionalParams[1] === "number" ? additionalParams[1] : additionalParams[1]?.key;

			let httpParams;
			if (citySK && postalCitySK) {
				httpParams = new HttpParams({
					fromObject: {
						citySK,
						postalCitySK,
					},
				});
			}

			return httpParams;
		};
	};

	resultTransformFn = (_: UiArguments) => (results: any) =>
		results && results.records?.length > 0 ? results.records[0].listingCitySK : null;

	searchFn = () => (httpParams: HttpParams) => {
		if (!httpParams) {
			return of([]);
		}
		return this.listingService.getListingCity(httpParams);
	};
}
